import { Job, Payment } from '@kanda-libs/ks-frontend-services';

import { FormattedJob } from 'types';

const PAYMENT_OPTION_CARD = 'card';

export const getLatestPaymentFromJob = (
  job: Job | FormattedJob | undefined,
): Payment | undefined => {
  const payments = job?.payments || [];
  const filteredPayments = payments.filter(
    (payment) => payment.payment_option.payment_method === PAYMENT_OPTION_CARD,
  );
  if (filteredPayments.length === 0) return undefined;
  if (filteredPayments.length === 1) return filteredPayments[0];
  const sorted = filteredPayments.sort(
    (payment1, payment2) =>
      new Date(payment2?.metadata?.created_at || 0).getTime() -
      new Date(payment1?.metadata?.created_at || 0).getTime(),
  );
  return sorted[0];
};

export const getLatestCardPaymentFromJob = (
  job: Job | FormattedJob | undefined,
): Payment | undefined => {
  const payments = job?.payments || [];
  const filteredPayments = payments.filter(
    (payment) => payment.payment_option.payment_method === 'card',
  );
  if (filteredPayments.length === 0) return undefined;
  if (filteredPayments.length === 1) return filteredPayments[0];
  const sorted = filteredPayments.sort(
    (payment1, payment2) =>
      new Date(payment2?.metadata?.created_at || 0).getTime() -
      new Date(payment1?.metadata?.created_at || 0).getTime(),
  );
  return sorted[0];
};

export const getLatestLoanPaymentFromJob = (
  job: Job | FormattedJob | undefined,
): Payment | undefined => {
  const payments = job?.payments || [];
  const filteredPayments = payments.filter(
    (payment) => payment.payment_option.payment_method === 'loan',
  );
  if (filteredPayments.length === 0) return undefined;
  if (filteredPayments.length === 1) return filteredPayments[0];
  const sorted = filteredPayments.sort(
    (payment1, payment2) =>
      new Date(payment2?.metadata?.created_at || 0).getTime() -
      new Date(payment1?.metadata?.created_at || 0).getTime(),
  );
  return sorted[0];
};

export const getLatestBankPaymentFromJob = (
  job: Job | FormattedJob | undefined,
): Payment | undefined => {
  const payments = job?.payments || [];
  const filteredPayments = payments.filter(
    (payment) => payment.payment_option.payment_method === 'bank',
  );
  if (filteredPayments.length === 0) return undefined;
  if (filteredPayments.length === 1) return filteredPayments[0];
  const sorted = filteredPayments.sort(
    (payment1, payment2) =>
      new Date(payment2?.metadata?.created_at || 0).getTime() -
      new Date(payment1?.metadata?.created_at || 0).getTime(),
  );
  return sorted[0];
};

export const getDepositPaymentFromJob = (
  job: Job | FormattedJob | undefined,
): Payment | undefined => {
  const payments = job?.payments;
  if (!payments) return undefined;
  const depositAmount = job.customer_options?.deposit_value?.amount;
  if (!depositAmount) return undefined;
  const nonLoanPayments = payments.filter(
    (payment) => payment.payment_option.payment_method !== 'loan',
  );
  if (nonLoanPayments.length === 0) return undefined;
  const depositMatchedPayments = nonLoanPayments.filter(
    (p) => p.payment_option.amount.amount === depositAmount,
  );
  if (depositMatchedPayments.length === 0) return undefined;
  const sorted = depositMatchedPayments.sort(
    (payment1, payment2) =>
      new Date(payment2?.metadata?.created_at || 0).getTime() -
      new Date(payment1?.metadata?.created_at || 0).getTime(),
  );
  return sorted[0];
};

export const getCreditId = (job: Job | FormattedJob | undefined): string => {
  if (!job) return '';
  if (job?.finance_status === 'not_applied') return '';
  const latestLoan = getLatestLoanPaymentFromJob(job);
  if (!latestLoan?.id) return '';
  return latestLoan.id;
};
